var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { HttpClient } from '@angular/common/http';
export class Http2 {
    constructor(httpClient, rootUrl) {
        this.httpClient = httpClient;
        this.rootUrl = rootUrl;
        this.tQuery = 'query';
        this.tMutation = 'mutation';
        if (rootUrl && !rootUrl.endsWith('/')) {
            rootUrl = rootUrl + '/';
        }
        this.rootUrl = rootUrl;
    }
    get url() {
        return this.rootUrl;
    }
    /**
     * Perform any request type
     */
    request(url, config) {
        if (config.body) {
            config.body = JSON.stringify(config.body);
        }
        config = Object.assign({ headers: {
                'Content-Type': 'application/json'
            }, params: {} }, config);
        url = this.rootUrl ? this.rootUrl + url : url;
        // remove any trailing slash from the url
        if (url.endsWith('/')) {
            url = url.substring(0, url.length - 1);
        }
        return this.httpClient.request(config.method, url, config).toPromise().then(result => {
            return result;
        }, errorResponse => {
            return Promise.reject(errorResponse.error);
        });
    }
    /**
     * Perform a GET graphql query
     * @param query GraphQL query
     * @param variables variables to be inserted into query
     * @param method "GET" | "POST" | "PUT" | "DELETE"
     * @param dataPath retrieves the data at the specified named path.
     */
    graphqlRequest(query, variables, method = 'GET', dataPath = null) {
        return __awaiter(this, void 0, void 0, function* () {
            let queryName;
            const type = query.trim().toLowerCase().startsWith(this.tQuery) ? this.tQuery : this.tMutation;
            if (type === this.tQuery) {
                // find the query name from the query and use that in the querystring to help with debugging to distinguish this request
                queryName = query.substring(query.indexOf(this.tQuery) + this.tQuery.length, query.indexOf('{')).trim();
            }
            else {
                queryName = query.substring(query.indexOf(this.tMutation) + this.tMutation.length, query.indexOf('(')).trim();
            }
            // remove any excess whitespace from the query only for GET requests since this is passed on the URL
            if (method === 'GET') {
                query = this.graphqlTrim(query);
            }
            let response;
            try {
                response = yield this.request(`graphql?${queryName}`, {
                    body: method !== 'GET' ? {
                        query,
                        variables
                    } : undefined,
                    method,
                    params: method === 'GET' ? {
                        query,
                        variables: JSON.stringify(variables)
                    } : undefined
                });
            }
            catch (e) {
                if (e && !e.message && e.errors && e.errors[0]) {
                    e.message = e.errors[0].message;
                }
                throw e;
            }
            if (!dataPath) {
                return response.data;
            }
            else {
                const parts = dataPath.split('.');
                let result = response.data;
                for (const part of parts) {
                    result = result[part];
                }
                return result;
            }
        });
    }
    graphqlTrim(text) {
        text = text.replace(/\s+/g, ' ');
        return text;
    }
    get(url, params, config) {
        const cfg = Object.assign({}, config, { method: 'GET', params });
        return this.request(url, cfg);
    }
    post(url, body, config) {
        const cfg = Object.assign({ body, method: 'POST' }, config);
        return this.request(url, cfg);
    }
    put(url, body, config) {
        const cfg = Object.assign({ body, method: 'PUT' }, config);
        return this.request(url, cfg);
    }
    delete(url, body, config) {
        const cfg = Object.assign({ body, method: 'DELETE' }, config);
        return this.request(url, cfg);
    }
}
export class Http2Factory {
    constructor(httpClient) {
        this.httpClient = httpClient;
    }
    create(url) {
        return new Http2(this.httpClient, url);
    }
}
